import galleryData from "../data/gallery.json";
import catsData from "../data/cats.json";

const toGalleryShape = (item) => ({
  name: item.title,
  src: item.image,
  thumbnail: "",
  lowRes: item.image,
  highRes: item.image,
  title: item.title,
  description: item.description || "",
});

export const defaultImages = galleryData.gallery.items.map(toGalleryShape);
export const cats = catsData.cats.items.map(toGalleryShape);
export const galleryRowConfig = galleryData.gallery.rowConfig;
export const catsRowConfig = catsData.cats.rowConfig;
